const expriences = [
  {
    id: 8,
    title: "Microsoft Certified: Power BI Data Analyst Associate (PL-300)",
    location: "",
    description:
      "Microsoft certification validating expertise in Power BI, including data modeling, DAX, report and dashboard design, and data-driven decision making. Demonstrates proficiency in transforming raw data into actionable business insights using the Microsoft Power Platform.",
    date: "2026",
    icon: "school",
  },
  {
    id: 7,
    title: "BS in Computer Science - Coastal Carolina University",
    location: "Conway, SC",
    description:
      "Bachelor of Science in Computer Science at Coastal Carolina University, expected graduation 2026. Focused on software engineering, algorithms, and AI/machine learning fundamentals while actively working as a Software Developer at RadixBay.",
    date: "2023 - 2026",
    icon: "school",
  },
  {
    id: 5,
    title: "Graph Developer - Associate",
    location: "Myrtle Beach, SC",
    description:
      "Skilled Graph Developer - Associate with a strong foundation in graph database technologies and data modeling principles, capable of developing and optimizing graph data solutions. Experienced in implementing graph algorithms, query optimization, and performance tuning to maximize system efficiency and data retrieval speed.",
    date: "2023 - 2024",
    icon: "school",
  },
  {
    id: 4,
    title: "Certification - AWS Cloud Practitioner Essentials",
    location: "Myrtle Beach, SC",
    description:
      "The AWS Certified Cloud Practitioner is an IT industry certification offered by Amazon. It's a certification that covers so many different AWS Cloud-related material, such as understanding essential cloud concepts and AWS services, security, architecture, pricing, and support.",
    date: "September 2022 - Present",
    icon: "school",
  },
  {
    id: 3,
    title: "RadixBay - Full Stack Web Developer",
    location: "Tybor City, NC",
    description:
      "RadixBay is Consulting and Managed Services with offices in Charlotte and Tabor City, NC. It is a model that combines the quality and security. Including application design, development, testing, cloud data infrastructure support, and project management.",
    date: "Jun 2021 - Present",
    icon: "work",
  },
  {
    id: 2,
    title: "AAS in Computer Technology - Programming",
    location: "Myrtle Beach, SC",
    description:
      "Associate degree at Horry-Georgetown Technical College covering Python, Java, JavaScript, HTML/CSS, mobile apps, and SQL.",
    date: "2018 - 2021",
    icon: "school",
  },
];

export default expriences;
